// src/pages/About.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import SEO from "../components/SEO";
import { seoConfig } from "../seoConfig";

import { useImageParallax } from "../hooks/useImageParallax";


import GetInTouch from '../components/GetInTouch';

import about1 from '../assets/images/about/08.jpg';




const About: React.FC = () => {

const seo = seoConfig.about; // ✅ Load meta for this page

useImageParallax(".anim-image-parallax"); // hook call








  return (


<>

      <SEO
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        url={seo.url}
        image={seo.image}
      />


  {/* rts bread crumba rea start */}
  <div className="rts-breadcrumb-area-about bg_image">
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <div className="baread-crumb-main-wrapper pt--100">
            <div className="inner">
              <h1 className="title rts_hero__title">About Us</h1>
              <span className="bg-text d-none d-md-inline">Manikarn Digital</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* rts bread crumba rea end */}





  {/* rts about area three */}
  <div
    className="rts-about-area parallax-about pt_sm--0 pb--80"
    id="about"
  >
    <div className="container">
      <div className="row g-5 align-items-center">
<div className="col-lg-5">
  <div className="pli-image-holder">
    <figure className="pli-image">
      <img
        className="anim-image-parallax tt-lazy"
        src={about1}
        data-src={about1}
        alt="image"
      />
    </figure>
  </div>
</div>

        <div className="col-lg-7">

  <div className="content-wrapper">
    <span className="sub-title">MANIKARN DIGITAL</span>
    <h2 className="title mt--15 mb--20 mt_sm--10 mb_sm--10">
      Your Trusted Digital Growth Partner
    </h2>
    <p className="disc">
      We are passionate about turning ideas into impactful digital experiences. Our mission is simple – to help businesses of all sizes build a strong online presence and reach their target audience effectively. Whether you are a startup or an established brand, our team of skilled professionals ensures your business thrives in today’s competitive digital world.
    </p>
    <p className="disc">
      We specialize in <strong>Website Design & Development</strong>, creating websites that are not only visually engaging but also highly user-friendly and performance-driven. Along with this, our <strong>SEO (Search Engine Optimization)</strong> strategies are designed to improve your website’s visibility on search engines, bringing in more organic traffic and qualified leads.
    </p>
    <p className="disc">
      Our expertise also extends to <strong>PPC Advertising</strong> and <strong>Social Media Marketing</strong>, where we craft data-driven campaigns to connect your brand with the right audience at the right time. To strengthen your digital presence further, we offer <strong>Content Marketing</strong> and <strong>Email Marketing</strong>, ensuring your customers stay engaged and connected.
    </p>
    <Link to="/contact" className="learn-more-btn mt--30">
      Contact Us <i className="fa-solid fa-arrow-up-right-from-square"></i>
    </Link>
  </div>


        </div>
      </div>
    </div>
  </div>
  {/* rts about area three end */}




  {/* our working process area start */}
  <div className="working-process-area pt_sm--0 pb--100 pb_sm--20">
    <div className="container">
      <div className="row">
        <div className="col-lg-6">
          <div className="text-start">
            <span className="sub-title">MANIKARN DIGITAL</span>
            <h2 className="title mt--15 mb--20 mt_sm--10 mb_sm--10">Our Working Process</h2>
          </div>
        </div>
      </div>
      <div className="row mt-0">
        <div className="col-lg-12">
          <div className="main-process-wrapper">
            {/* single process area start */}
            <div className="single-working-process-three">
              <div className="icon">
                <img src="assets/images/working-process/icon/01.png" alt="" />
              </div>
              <h5 className="title">Discovery & Strategy</h5>
              <p className="disc">
                We start by understanding your business goals, target audience, and competition. This helps us create a clear strategy that aligns with your vision and sets the foundation for success.
              </p>
            </div>
            {/* single process area end */}
            {/* single process area start */}
            <div className="single-working-process-three">
              <div className="icon">
                <img src="assets/images/working-process/icon/02.png" alt="" />
              </div>
              <h5 className="title">Design & Development</h5>
              <p className="disc">
                Our creative designers and developers bring your ideas to life with modern, responsive, and user-friendly websites that deliver a seamless digital experience.
              </p>
            </div>
            {/* single process area end */}
            {/* single process area start */}
            <div className="single-working-process-three">
              <div className="icon">
                <img src="assets/images/working-process/icon/03.png" alt="" />
              </div>
              <h5 className="title">Marketing & Optimization</h5>
              <p className="disc">
                Through SEO, PPC, and social media marketing, we implement data-driven campaigns to boost your visibility, attract quality leads, and maximize ROI.
              </p>
            </div>
            {/* single process area end */}
            {/* single process area start */}
            <div className="single-working-process-three">
              <div className="icon">
                <img src="assets/images/working-process/icon/04.png" alt="" />
              </div>
              <h5 className="title">Support & Growth</h5>
              <p className="disc">
                We provide ongoing hosting, maintenance, and digital support to ensure your website performs at its best while helping you scale your business online.
              </p>
            </div>
            {/* single process area end */}
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* our working process area end */}









{/* ==== GetInTouch Section start ==== */}
<GetInTouch />
{/* ==== / GetInTouch Section end ==== */}  




</>


  );
};

export default About;
